module.exports = __webpack_public_path__ + "static/_/src/config/gridViewConfigs/gameInterface/sound/02//t01.mp3";